const heroScroll = {
  init () {
    if ($('.homepage-slider').length){
      $('.homepage-slider').slick({
          lazyLoad: 'ondemand', // ondemand progressive anticipated
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          infinite: true,
          fade: true,
          autoplaySpeed: 5000,
        });
    }
    if ($(".scroll-down").length) {
      $(".scroll-down").click(function() {
        if ($(".top-of-content").length) {
            $('html, body').animate({
                scrollTop: $(".top-of-content").offset().top - 80
            }, 1500);
          }
       });
     }
  }
};
export default heroScroll;



// WEBPACK FOOTER //
// ./src/components/02-objects/14-hero/14-hero.js